import { StatusMessages } from '~/components/Checkout/SuccessPage/StatusBox/StatusBoxUtils'
import { FestivalCodesEnum, Region } from '~/generated/graphql'
import { MetadataType } from '~/layout/Head/HeadTypes'
import { gt as GT } from '~/locale'
import { FestivalSalesOffer } from '~/types/festival'

import { voucherImages } from './pl/assets/pageImages'
import { mobileAppLogos } from './pl/assets/pageImages/mobile-apps'
import { marketingConsent } from './pl/copy'
import { voucherTranslation } from './pl/copy/pageTranslate'

export type MarketCode = 'pl' | 'cz' | 'de'

export type EarlyReservationTranslations = {
  bottomSection: null | ((gt: typeof GT) => string)
}

export type FooterInfo = {
  addressLines?: string[]
}

export type ClubConfigCopy = {
  rwReservationStatusMessages: (gt: typeof GT) => StatusMessages
  giftStatusMessages: (gt: typeof GT) => StatusMessages
  beforeYouVisitTitle: (gt: typeof GT) => string
  beforeYouVisitDefaultDescription: (gt: typeof GT) => string
  voucher: typeof voucherTranslation
  marketingConsent: typeof marketingConsent
  metadata: (gt: typeof GT) => {
    default: MetadataType
    festivals: Partial<Record<FestivalCodesEnum, { title: string; description: string; imageUrl: string; imageAlt: string }>>
  }
  earlyReservation: EarlyReservationTranslations
  footerInfo: FooterInfo
}

export type ClubConfigPaths = {
  socialMedia: Array<{ social: 'facebook' | 'linkedin' | 'tiktok' | 'instagram'; href: string }>
  resetPasswordUrl: { redirectUrl: string; onExitUrl: string; shallow: boolean }
}

export type ClubConfigAssets = {
  voucher: typeof voucherImages
  mobileAppLogos: typeof mobileAppLogos
}

export type Logos = Partial<Record<FestivalCodesEnum | 'club', { centered: string; left: string }>>

export type ClubConfig = {
  aboutPageEnabled: boolean
  assets: ClubConfigAssets
  blikEnabled: boolean
  blogEnabled: boolean
  careerPageEnabled: boolean
  chmEnabled: boolean
  copy: ClubConfigCopy
  paths: ClubConfigPaths
  customRwSuccessCopy: boolean
  d2dEnabled: boolean
  defaultGeolocation: { latitude: number; longitude: number }
  defaultRegion: Pick<Region, 'id' | 'name'>
  directCardPaymentEnabled: boolean
  enabledLanguages: Record<string, string>
  extraMarketingConsentEnabled: boolean
  festivalSalesOffer: FestivalSalesOffer
  footerAwardsEnabled: boolean
  klarnaEnabled: boolean
  logos: Logos
  otherFestivalsEnabled: boolean
  paypoEnabled: boolean
  redirectHeroToLandingEnabled: boolean
  restaurantsListingEnabled: boolean
  showFooterCopyright: boolean
  sideEventListingPageEnabled: boolean
  useRWInsteadOfRC: boolean
  visaMobileEnabled: boolean
  hideRCInfo: boolean
  currencyFormat: string
  supportEmail: string
  redirectRestaurantPageToListing: FestivalCodesEnum | false
  supportPhone?: string
  tin: {
    placeholder: string
    minLength: number
    maxLength: number
  }
  showReservationCancelledDescription: boolean
}

// voucher ____________________________________________________________________________

// /assets

type BannerBreakpoint = {
  desktop: string
  mobile: string
}

export enum EventsListingRoutes {
  GiftEventsListing = 'gift-events-listing',
  SideEventsListing = 'side-events-listing',
}

export type GiftEventsListingBanners = {
  [EventsListingRoutes.GiftEventsListing]: {
    mainBanner: BannerBreakpoint
    bottomBanner?: BannerBreakpoint
  }
  [EventsListingRoutes.SideEventsListing]: {
    mainBanner: BannerBreakpoint
    bottomBanner?: BannerBreakpoint
  }
}

// _____________________________________________________________________________________
